var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tsny_resource-link",on:{"click":function($event){return _vm.downloadResource(_vm.resource.name, _vm.resource._id)}}},[_vm._v(_vm._s(_vm.resource.name))])}
var staticRenderFns = []

export { render, staticRenderFns }